<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("prepare-share-document.title") }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="close"
                ></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{
                        $t("prepare-share-document.document-for-share")
                    }}</label>
                    <div class="control">
                        <div class="file is-centered has-name is-boxed">
                            <label class="file-label">
                                <input
                                    ref="fileInput"
                                    type="file"
                                    class="file-input"
                                    accept="application/pdf,.doc,.docx,
                                       application/msword,application/vnd.
                                       openxmlformats-officedocument.wordprocessingml.document"
                                    @change="fileChange"
                                />
                                <span class="file-cta">
                                    <span class="file-icon">
                                        <i class="fas fa-upload"></i>
                                    </span>
                                    <span class="file-label">
                                        {{
                                            $t(
                                                "prepare-share-document.select-file"
                                            )
                                        }}
                                    </span>
                                </span>
                                <span v-if="fileName" class="file-name">
                                    {{ fileName }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="share" :disabled="emptyFile">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span> {{ $t("prepare-share-document.share") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "prepare-share-document",
    data() {
        return {
            file: null,
        };
    },
    computed: {
        ...mapGetters("conference", ["getConferenceId"]),
        fileName() {
            return this.file === null ? null : this.file.name;
        },
        emptyFile() {
            return this.file === null;
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        fileChange(event) {
            if (event.target.files !== undefined) {
                this.file = event.target.files[0];
                this.$refs.fileInput.value = "";
            }
        },
        async share() {
            let roomId = this.getConferenceId;

            let formData = new FormData();
            formData.append("name", this.file.name);
            formData.append("roomId", roomId);
            formData.append("file", this.file);

            let response = await RepositoryFactory.files.shareFile(formData);
            window.console.log(response);

            if (response.status === 200) {
                let fileId = response.data;
                this.$emit("sendAction", {
                    type: "share-document",
                    title: this.file.name,
                    state: 1,
                    answer: {
                        fileId: fileId,
                    },
                });
                this.$emit("close");
            } else {
                // Show error
            }
        },
    },
};
</script>